import { render, staticRenderFns } from "./v0.vue?vue&type=template&id=1ffd1bdc&scoped=true&"
import script from "./v0.vue?vue&type=script&lang=js&"
export * from "./v0.vue?vue&type=script&lang=js&"
import style0 from "./v0.vue?vue&type=style&index=0&id=1ffd1bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd1bdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ffd1bdc')) {
      api.createRecord('1ffd1bdc', component.options)
    } else {
      api.reload('1ffd1bdc', component.options)
    }
    module.hot.accept("./v0.vue?vue&type=template&id=1ffd1bdc&scoped=true&", function () {
      api.rerender('1ffd1bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/agent-dashboard/v0.vue"
export default component.exports